import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import ChevronDown from 'assets/svg/ChevronDown';
import SignOut from 'assets/svg/SignOut';
import SettingsIcon from 'assets/svg/SettingsGear';
import QuestionIcon from 'assets/svg/Question';
import BookIcon from 'assets/svg/MenuBook';

import {
  UserChipWrapper,
  UserChipTrigger,
  Avatar,
  UserName,
  ChevronIcon,
  DropdownContent,
  DropdownItem,
  DropdownSeparator,
  DropdownLogoutButton,
} from './styles';

const UserChip = ({ initials, firstName, status, onLogout, isMobile }) => {
  const { t } = useTranslation('app');
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = useCallback(() => setIsOpen(($) => !$), []);
  const closeMenu = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('click', closeMenu);

      return () => document.removeEventListener('click', closeMenu);
    }

    return () => null;
  }, [closeMenu, isOpen]);

  const handleLogout = useCallback(() => {
    onLogout();
    closeMenu();
  }, [onLogout, closeMenu]);

  return (
    <UserChipWrapper>
      <UserChipTrigger type="button" onClick={toggleMenu} $isOpen={isOpen}>
        <Avatar>{initials}</Avatar>
        {!isMobile && <UserName>{firstName}</UserName>}
        {!isMobile && (
          <ChevronIcon $isOpen={isOpen}>
            <ChevronDown />
          </ChevronIcon>
        )}
      </UserChipTrigger>

      <DropdownContent $isOpen={isOpen} onClick={(e) => e.stopPropagation()}>
        <DropdownItem to="/account" onClick={closeMenu}>
          <SettingsIcon />
          {t('My profile')}
        </DropdownItem>
        {status !== 3 && (
          <DropdownItem to="/meine-kurse" onClick={closeMenu}>
            <BookIcon />
            {t('My courses')}
          </DropdownItem>
        )}
        <DropdownItem to="/support" onClick={closeMenu}>
          <QuestionIcon />
          {t('Help Center')}
        </DropdownItem>
        <DropdownSeparator />
        <DropdownLogoutButton type="button" onClick={handleLogout}>
          <SignOut />
          {t('Logout')}
        </DropdownLogoutButton>
      </DropdownContent>
    </UserChipWrapper>
  );
};

UserChip.propTypes = {
  initials: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  status: PropTypes.number,
  onLogout: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

UserChip.defaultProps = {
  status: null,
  isMobile: false,
};

export default UserChip;
